import apiService from "./ApiService";

class RefreshService {

    async get() {
        return await apiService.get('/refresh');
    }
}

export default new RefreshService();